'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _localStorage = require('../localStorage');

var storage = _interopRequireWildcard(_localStorage);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var localStorage = storage.localStorage;

var prefix = 'chat-app';

var set = function set(key, value) {
  try {
    localStorage.setItem(prefix + '-' + key, value);
  } catch (e) {
    //
  }
};

var get = function get(key) {
  try {
    return localStorage.getItem(prefix + '-' + key) || null;
  } catch (e) {
    return null;
  }
};

var remove = function remove(key) {
  try {
    if (Array.isArray(key)) {
      key.forEach(function (el) {
        localStorage.removeItem(prefix + '-' + el);
      });
    } else {
      localStorage.removeItem(prefix + '-' + key);
    }
  } catch (e) {
    //
  }
};

exports.default = {
  get: get,
  set: set,
  remove: remove
};